import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_j6d3pdgeyx: FaireBrandEntity = {
  token: "b_j6d3pdgeyx",
  type: "brand",
  name: "Great Stuff Novelties (GSN) by NMR Brands",
  avatarUrl:
    "https://cdn.faire.com/fastly/a6c30fe1f312df6d70a89a521c9e0109067042c06c6fe1097220581503a22abb.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/5e7c2cef9d2fa6ad79f00a0912c62bfbebf4af12a73684a266ce110259bb580f.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/a6c30fe1f312df6d70a89a521c9e0109067042c06c6fe1097220581503a22abb.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5e7c2cef9d2fa6ad79f00a0912c62bfbebf4af12a73684a266ce110259bb580f.jpeg",
  location: "Valencia, CA, USA",
  minimumOrderDollars: 200,
  rating: 5,
  reviewCount: 24,
  isInsider: true,
  description:
    "GREAT STUFF NOVELTIES (aka GSN) by NMR Brands brings you a wide assortment of print-on-demand mugs, magnets, and buttons in both licensed and non-licensed varieties. Colorful and entertaining, these products will catch your eye and tickle your funny bone.\n\nSince its inception in 1999, NMR Brands has become a global provider of licensed and branded Games, Puzzles, Playing Cards, and Lifestyle Products.  We market our products under our trademarked brands AQUARIUS, GAMAGO, and GREAT STUFF NOVELTIES.",
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:36:09.553Z",
    importedBy: "entity-db-cli",
  },
};
